export default __webpack_public_path__ + "c575a0eac82b66ecd461233001f145c9.svg";